/* eslint-disable */
// GENERATED FILE. Do not edit by hand.
// Regenerate: pnpm --filter @tellescope/i18n generate:locales
// Kept in sync by the pre-commit hook and prepare-translations; CI fails if this file is stale.
//
// Why a static index instead of `import.meta.glob`: that API is Vite-only, and this package must stay
// importable from Node (Lambda, scripts) and React Native. See CLAUDE.md.
import type { Resource } from "i18next";

import ar_account from "./locales/ar/account.json";
import ar_ai_agent from "./locales/ar/ai-agent.json";
import ar_ai from "./locales/ar/ai.json";
import ar_analytics from "./locales/ar/analytics.json";
import ar_appointment_reminders from "./locales/ar/appointment-reminders.json";
import ar_appointments from "./locales/ar/appointments.json";
import ar_auth from "./locales/ar/auth.json";
import ar_button from "./locales/ar/button.json";
import ar_buttons from "./locales/ar/buttons.json";
import ar_calendar from "./locales/ar/calendar.json";
import ar_call_queues from "./locales/ar/call-queues.json";
import ar_calling from "./locales/ar/calling.json";
import ar_common from "./locales/ar/common.json";
import ar_compose from "./locales/ar/compose.json";
import ar_contact from "./locales/ar/contact.json";
import ar_contacts from "./locales/ar/contacts.json";
import ar_content from "./locales/ar/content.json";
import ar_dashboard from "./locales/ar/dashboard.json";
import ar_dates from "./locales/ar/dates.json";
import ar_device_orders from "./locales/ar/device-orders.json";
import ar_eligibility from "./locales/ar/eligibility.json";
import ar_email from "./locales/ar/email.json";
import ar_emojis from "./locales/ar/emojis.json";
import ar_encounters from "./locales/ar/encounters.json";
import ar_endusers from "./locales/ar/endusers.json";
import ar_events from "./locales/ar/events.json";
import ar_files from "./locales/ar/files.json";
import ar_forms from "./locales/ar/forms.json";
import ar_inbox from "./locales/ar/inbox.json";
import ar_layout from "./locales/ar/layout.json";
import ar_llm_testbench from "./locales/ar/llm-testbench.json";
import ar_medications from "./locales/ar/medications.json";
import ar_messages from "./locales/ar/messages.json";
import ar_messaging from "./locales/ar/messaging.json";
import ar_mfa from "./locales/ar/mfa.json";
import ar_missing from "./locales/ar/missing.json";
import ar_navigation from "./locales/ar/navigation.json";
import ar_notifications from "./locales/ar/notifications.json";
import ar_onboarding from "./locales/ar/onboarding.json";
import ar_orders from "./locales/ar/orders.json";
import ar_payments from "./locales/ar/payments.json";
import ar_portal from "./locales/ar/portal.json";
import ar_prototypes from "./locales/ar/prototypes.json";
import ar_purchases from "./locales/ar/purchases.json";
import ar_routing from "./locales/ar/routing.json";
import ar_scripts from "./locales/ar/scripts.json";
import ar_settings from "./locales/ar/settings.json";
import ar_shop from "./locales/ar/shop.json";
import ar_sidebar from "./locales/ar/sidebar.json";
import ar_tags from "./locales/ar/tags.json";
import ar_team_chat from "./locales/ar/team-chat.json";
import ar_team_channel from "./locales/ar/team_channel.json";
import ar_templates from "./locales/ar/templates.json";
import ar_test from "./locales/ar/test.json";
import ar_ticket_queues from "./locales/ar/ticket-queues.json";
import ar_tickets from "./locales/ar/tickets.json";
import ar_timeline from "./locales/ar/timeline.json";
import ar_ui from "./locales/ar/ui.json";
import ar_unsubscribe from "./locales/ar/unsubscribe.json";
import ar_utils from "./locales/ar/utils.json";
import ar_videoCalling from "./locales/ar/videoCalling.json";
import ar_vitals from "./locales/ar/vitals.json";
import de_account from "./locales/de/account.json";
import de_ai_agent from "./locales/de/ai-agent.json";
import de_ai from "./locales/de/ai.json";
import de_analytics from "./locales/de/analytics.json";
import de_appointment_reminders from "./locales/de/appointment-reminders.json";
import de_appointments from "./locales/de/appointments.json";
import de_auth from "./locales/de/auth.json";
import de_button from "./locales/de/button.json";
import de_buttons from "./locales/de/buttons.json";
import de_calendar from "./locales/de/calendar.json";
import de_call_queues from "./locales/de/call-queues.json";
import de_calling from "./locales/de/calling.json";
import de_common from "./locales/de/common.json";
import de_compose from "./locales/de/compose.json";
import de_contact from "./locales/de/contact.json";
import de_contacts from "./locales/de/contacts.json";
import de_content from "./locales/de/content.json";
import de_dashboard from "./locales/de/dashboard.json";
import de_dates from "./locales/de/dates.json";
import de_device_orders from "./locales/de/device-orders.json";
import de_eligibility from "./locales/de/eligibility.json";
import de_email from "./locales/de/email.json";
import de_emojis from "./locales/de/emojis.json";
import de_encounters from "./locales/de/encounters.json";
import de_endusers from "./locales/de/endusers.json";
import de_events from "./locales/de/events.json";
import de_files from "./locales/de/files.json";
import de_forms from "./locales/de/forms.json";
import de_inbox from "./locales/de/inbox.json";
import de_layout from "./locales/de/layout.json";
import de_llm_testbench from "./locales/de/llm-testbench.json";
import de_medications from "./locales/de/medications.json";
import de_messages from "./locales/de/messages.json";
import de_messaging from "./locales/de/messaging.json";
import de_mfa from "./locales/de/mfa.json";
import de_missing from "./locales/de/missing.json";
import de_navigation from "./locales/de/navigation.json";
import de_notifications from "./locales/de/notifications.json";
import de_onboarding from "./locales/de/onboarding.json";
import de_orders from "./locales/de/orders.json";
import de_payments from "./locales/de/payments.json";
import de_portal from "./locales/de/portal.json";
import de_prototypes from "./locales/de/prototypes.json";
import de_purchases from "./locales/de/purchases.json";
import de_routing from "./locales/de/routing.json";
import de_scripts from "./locales/de/scripts.json";
import de_settings from "./locales/de/settings.json";
import de_shop from "./locales/de/shop.json";
import de_sidebar from "./locales/de/sidebar.json";
import de_tags from "./locales/de/tags.json";
import de_team_chat from "./locales/de/team-chat.json";
import de_team_channel from "./locales/de/team_channel.json";
import de_templates from "./locales/de/templates.json";
import de_test from "./locales/de/test.json";
import de_ticket_queues from "./locales/de/ticket-queues.json";
import de_tickets from "./locales/de/tickets.json";
import de_timeline from "./locales/de/timeline.json";
import de_ui from "./locales/de/ui.json";
import de_unsubscribe from "./locales/de/unsubscribe.json";
import de_utils from "./locales/de/utils.json";
import de_videoCalling from "./locales/de/videoCalling.json";
import de_vitals from "./locales/de/vitals.json";
import en_account from "./locales/en/account.json";
import en_ai_agent from "./locales/en/ai-agent.json";
import en_ai from "./locales/en/ai.json";
import en_analytics from "./locales/en/analytics.json";
import en_appointment_reminders from "./locales/en/appointment-reminders.json";
import en_appointments from "./locales/en/appointments.json";
import en_auth from "./locales/en/auth.json";
import en_button from "./locales/en/button.json";
import en_buttons from "./locales/en/buttons.json";
import en_calendar from "./locales/en/calendar.json";
import en_call_queues from "./locales/en/call-queues.json";
import en_calling from "./locales/en/calling.json";
import en_common from "./locales/en/common.json";
import en_compose from "./locales/en/compose.json";
import en_contact from "./locales/en/contact.json";
import en_contacts from "./locales/en/contacts.json";
import en_content from "./locales/en/content.json";
import en_dashboard from "./locales/en/dashboard.json";
import en_dates from "./locales/en/dates.json";
import en_device_orders from "./locales/en/device-orders.json";
import en_eligibility from "./locales/en/eligibility.json";
import en_email from "./locales/en/email.json";
import en_emojis from "./locales/en/emojis.json";
import en_encounters from "./locales/en/encounters.json";
import en_endusers from "./locales/en/endusers.json";
import en_events from "./locales/en/events.json";
import en_files from "./locales/en/files.json";
import en_forms from "./locales/en/forms.json";
import en_inbox from "./locales/en/inbox.json";
import en_layout from "./locales/en/layout.json";
import en_llm_testbench from "./locales/en/llm-testbench.json";
import en_medications from "./locales/en/medications.json";
import en_messages from "./locales/en/messages.json";
import en_messaging from "./locales/en/messaging.json";
import en_mfa from "./locales/en/mfa.json";
import en_missing from "./locales/en/missing.json";
import en_navigation from "./locales/en/navigation.json";
import en_notifications from "./locales/en/notifications.json";
import en_onboarding from "./locales/en/onboarding.json";
import en_orders from "./locales/en/orders.json";
import en_payments from "./locales/en/payments.json";
import en_portal from "./locales/en/portal.json";
import en_prototypes from "./locales/en/prototypes.json";
import en_purchases from "./locales/en/purchases.json";
import en_routing from "./locales/en/routing.json";
import en_scripts from "./locales/en/scripts.json";
import en_settings from "./locales/en/settings.json";
import en_shop from "./locales/en/shop.json";
import en_sidebar from "./locales/en/sidebar.json";
import en_tags from "./locales/en/tags.json";
import en_team_chat from "./locales/en/team-chat.json";
import en_team_channel from "./locales/en/team_channel.json";
import en_templates from "./locales/en/templates.json";
import en_test from "./locales/en/test.json";
import en_ticket_queues from "./locales/en/ticket-queues.json";
import en_tickets from "./locales/en/tickets.json";
import en_timeline from "./locales/en/timeline.json";
import en_ui from "./locales/en/ui.json";
import en_unsubscribe from "./locales/en/unsubscribe.json";
import en_utils from "./locales/en/utils.json";
import en_videoCalling from "./locales/en/videoCalling.json";
import en_vitals from "./locales/en/vitals.json";
import es_account from "./locales/es/account.json";
import es_ai_agent from "./locales/es/ai-agent.json";
import es_ai from "./locales/es/ai.json";
import es_analytics from "./locales/es/analytics.json";
import es_appointment_reminders from "./locales/es/appointment-reminders.json";
import es_appointments from "./locales/es/appointments.json";
import es_auth from "./locales/es/auth.json";
import es_button from "./locales/es/button.json";
import es_buttons from "./locales/es/buttons.json";
import es_calendar from "./locales/es/calendar.json";
import es_call_queues from "./locales/es/call-queues.json";
import es_calling from "./locales/es/calling.json";
import es_common from "./locales/es/common.json";
import es_compose from "./locales/es/compose.json";
import es_contact from "./locales/es/contact.json";
import es_contacts from "./locales/es/contacts.json";
import es_content from "./locales/es/content.json";
import es_dashboard from "./locales/es/dashboard.json";
import es_dates from "./locales/es/dates.json";
import es_device_orders from "./locales/es/device-orders.json";
import es_eligibility from "./locales/es/eligibility.json";
import es_email from "./locales/es/email.json";
import es_emojis from "./locales/es/emojis.json";
import es_encounters from "./locales/es/encounters.json";
import es_endusers from "./locales/es/endusers.json";
import es_events from "./locales/es/events.json";
import es_files from "./locales/es/files.json";
import es_forms from "./locales/es/forms.json";
import es_inbox from "./locales/es/inbox.json";
import es_layout from "./locales/es/layout.json";
import es_llm_testbench from "./locales/es/llm-testbench.json";
import es_medications from "./locales/es/medications.json";
import es_messages from "./locales/es/messages.json";
import es_messaging from "./locales/es/messaging.json";
import es_mfa from "./locales/es/mfa.json";
import es_missing from "./locales/es/missing.json";
import es_navigation from "./locales/es/navigation.json";
import es_notifications from "./locales/es/notifications.json";
import es_onboarding from "./locales/es/onboarding.json";
import es_orders from "./locales/es/orders.json";
import es_payments from "./locales/es/payments.json";
import es_portal from "./locales/es/portal.json";
import es_prototypes from "./locales/es/prototypes.json";
import es_purchases from "./locales/es/purchases.json";
import es_routing from "./locales/es/routing.json";
import es_scripts from "./locales/es/scripts.json";
import es_settings from "./locales/es/settings.json";
import es_shop from "./locales/es/shop.json";
import es_sidebar from "./locales/es/sidebar.json";
import es_tags from "./locales/es/tags.json";
import es_team_chat from "./locales/es/team-chat.json";
import es_team_channel from "./locales/es/team_channel.json";
import es_templates from "./locales/es/templates.json";
import es_test from "./locales/es/test.json";
import es_ticket_queues from "./locales/es/ticket-queues.json";
import es_tickets from "./locales/es/tickets.json";
import es_timeline from "./locales/es/timeline.json";
import es_ui from "./locales/es/ui.json";
import es_unsubscribe from "./locales/es/unsubscribe.json";
import es_utils from "./locales/es/utils.json";
import es_videoCalling from "./locales/es/videoCalling.json";
import es_vitals from "./locales/es/vitals.json";
import fr_account from "./locales/fr/account.json";
import fr_ai_agent from "./locales/fr/ai-agent.json";
import fr_ai from "./locales/fr/ai.json";
import fr_analytics from "./locales/fr/analytics.json";
import fr_appointment_reminders from "./locales/fr/appointment-reminders.json";
import fr_appointments from "./locales/fr/appointments.json";
import fr_auth from "./locales/fr/auth.json";
import fr_button from "./locales/fr/button.json";
import fr_buttons from "./locales/fr/buttons.json";
import fr_calendar from "./locales/fr/calendar.json";
import fr_call_queues from "./locales/fr/call-queues.json";
import fr_calling from "./locales/fr/calling.json";
import fr_common from "./locales/fr/common.json";
import fr_compose from "./locales/fr/compose.json";
import fr_contact from "./locales/fr/contact.json";
import fr_contacts from "./locales/fr/contacts.json";
import fr_content from "./locales/fr/content.json";
import fr_dashboard from "./locales/fr/dashboard.json";
import fr_dates from "./locales/fr/dates.json";
import fr_device_orders from "./locales/fr/device-orders.json";
import fr_eligibility from "./locales/fr/eligibility.json";
import fr_email from "./locales/fr/email.json";
import fr_emojis from "./locales/fr/emojis.json";
import fr_encounters from "./locales/fr/encounters.json";
import fr_endusers from "./locales/fr/endusers.json";
import fr_events from "./locales/fr/events.json";
import fr_files from "./locales/fr/files.json";
import fr_forms from "./locales/fr/forms.json";
import fr_inbox from "./locales/fr/inbox.json";
import fr_layout from "./locales/fr/layout.json";
import fr_llm_testbench from "./locales/fr/llm-testbench.json";
import fr_medications from "./locales/fr/medications.json";
import fr_messages from "./locales/fr/messages.json";
import fr_messaging from "./locales/fr/messaging.json";
import fr_mfa from "./locales/fr/mfa.json";
import fr_missing from "./locales/fr/missing.json";
import fr_navigation from "./locales/fr/navigation.json";
import fr_notifications from "./locales/fr/notifications.json";
import fr_onboarding from "./locales/fr/onboarding.json";
import fr_orders from "./locales/fr/orders.json";
import fr_payments from "./locales/fr/payments.json";
import fr_portal from "./locales/fr/portal.json";
import fr_prototypes from "./locales/fr/prototypes.json";
import fr_purchases from "./locales/fr/purchases.json";
import fr_routing from "./locales/fr/routing.json";
import fr_scripts from "./locales/fr/scripts.json";
import fr_settings from "./locales/fr/settings.json";
import fr_shop from "./locales/fr/shop.json";
import fr_sidebar from "./locales/fr/sidebar.json";
import fr_tags from "./locales/fr/tags.json";
import fr_team_chat from "./locales/fr/team-chat.json";
import fr_team_channel from "./locales/fr/team_channel.json";
import fr_templates from "./locales/fr/templates.json";
import fr_test from "./locales/fr/test.json";
import fr_ticket_queues from "./locales/fr/ticket-queues.json";
import fr_tickets from "./locales/fr/tickets.json";
import fr_timeline from "./locales/fr/timeline.json";
import fr_ui from "./locales/fr/ui.json";
import fr_unsubscribe from "./locales/fr/unsubscribe.json";
import fr_utils from "./locales/fr/utils.json";
import fr_videoCalling from "./locales/fr/videoCalling.json";
import fr_vitals from "./locales/fr/vitals.json";
import hi_account from "./locales/hi/account.json";
import hi_ai_agent from "./locales/hi/ai-agent.json";
import hi_ai from "./locales/hi/ai.json";
import hi_analytics from "./locales/hi/analytics.json";
import hi_appointment_reminders from "./locales/hi/appointment-reminders.json";
import hi_appointments from "./locales/hi/appointments.json";
import hi_auth from "./locales/hi/auth.json";
import hi_button from "./locales/hi/button.json";
import hi_buttons from "./locales/hi/buttons.json";
import hi_calendar from "./locales/hi/calendar.json";
import hi_call_queues from "./locales/hi/call-queues.json";
import hi_calling from "./locales/hi/calling.json";
import hi_common from "./locales/hi/common.json";
import hi_compose from "./locales/hi/compose.json";
import hi_contact from "./locales/hi/contact.json";
import hi_contacts from "./locales/hi/contacts.json";
import hi_content from "./locales/hi/content.json";
import hi_dashboard from "./locales/hi/dashboard.json";
import hi_dates from "./locales/hi/dates.json";
import hi_device_orders from "./locales/hi/device-orders.json";
import hi_eligibility from "./locales/hi/eligibility.json";
import hi_email from "./locales/hi/email.json";
import hi_emojis from "./locales/hi/emojis.json";
import hi_encounters from "./locales/hi/encounters.json";
import hi_endusers from "./locales/hi/endusers.json";
import hi_events from "./locales/hi/events.json";
import hi_files from "./locales/hi/files.json";
import hi_forms from "./locales/hi/forms.json";
import hi_inbox from "./locales/hi/inbox.json";
import hi_layout from "./locales/hi/layout.json";
import hi_llm_testbench from "./locales/hi/llm-testbench.json";
import hi_medications from "./locales/hi/medications.json";
import hi_messages from "./locales/hi/messages.json";
import hi_messaging from "./locales/hi/messaging.json";
import hi_mfa from "./locales/hi/mfa.json";
import hi_missing from "./locales/hi/missing.json";
import hi_navigation from "./locales/hi/navigation.json";
import hi_notifications from "./locales/hi/notifications.json";
import hi_onboarding from "./locales/hi/onboarding.json";
import hi_orders from "./locales/hi/orders.json";
import hi_payments from "./locales/hi/payments.json";
import hi_portal from "./locales/hi/portal.json";
import hi_prototypes from "./locales/hi/prototypes.json";
import hi_purchases from "./locales/hi/purchases.json";
import hi_routing from "./locales/hi/routing.json";
import hi_scripts from "./locales/hi/scripts.json";
import hi_settings from "./locales/hi/settings.json";
import hi_shop from "./locales/hi/shop.json";
import hi_sidebar from "./locales/hi/sidebar.json";
import hi_tags from "./locales/hi/tags.json";
import hi_team_chat from "./locales/hi/team-chat.json";
import hi_team_channel from "./locales/hi/team_channel.json";
import hi_templates from "./locales/hi/templates.json";
import hi_test from "./locales/hi/test.json";
import hi_ticket_queues from "./locales/hi/ticket-queues.json";
import hi_tickets from "./locales/hi/tickets.json";
import hi_timeline from "./locales/hi/timeline.json";
import hi_ui from "./locales/hi/ui.json";
import hi_unsubscribe from "./locales/hi/unsubscribe.json";
import hi_utils from "./locales/hi/utils.json";
import hi_videoCalling from "./locales/hi/videoCalling.json";
import hi_vitals from "./locales/hi/vitals.json";
import ja_account from "./locales/ja/account.json";
import ja_ai_agent from "./locales/ja/ai-agent.json";
import ja_ai from "./locales/ja/ai.json";
import ja_analytics from "./locales/ja/analytics.json";
import ja_appointment_reminders from "./locales/ja/appointment-reminders.json";
import ja_appointments from "./locales/ja/appointments.json";
import ja_auth from "./locales/ja/auth.json";
import ja_button from "./locales/ja/button.json";
import ja_buttons from "./locales/ja/buttons.json";
import ja_calendar from "./locales/ja/calendar.json";
import ja_call_queues from "./locales/ja/call-queues.json";
import ja_calling from "./locales/ja/calling.json";
import ja_common from "./locales/ja/common.json";
import ja_compose from "./locales/ja/compose.json";
import ja_contact from "./locales/ja/contact.json";
import ja_contacts from "./locales/ja/contacts.json";
import ja_content from "./locales/ja/content.json";
import ja_dashboard from "./locales/ja/dashboard.json";
import ja_dates from "./locales/ja/dates.json";
import ja_device_orders from "./locales/ja/device-orders.json";
import ja_eligibility from "./locales/ja/eligibility.json";
import ja_email from "./locales/ja/email.json";
import ja_emojis from "./locales/ja/emojis.json";
import ja_encounters from "./locales/ja/encounters.json";
import ja_endusers from "./locales/ja/endusers.json";
import ja_events from "./locales/ja/events.json";
import ja_files from "./locales/ja/files.json";
import ja_forms from "./locales/ja/forms.json";
import ja_inbox from "./locales/ja/inbox.json";
import ja_layout from "./locales/ja/layout.json";
import ja_llm_testbench from "./locales/ja/llm-testbench.json";
import ja_medications from "./locales/ja/medications.json";
import ja_messages from "./locales/ja/messages.json";
import ja_messaging from "./locales/ja/messaging.json";
import ja_mfa from "./locales/ja/mfa.json";
import ja_missing from "./locales/ja/missing.json";
import ja_navigation from "./locales/ja/navigation.json";
import ja_notifications from "./locales/ja/notifications.json";
import ja_onboarding from "./locales/ja/onboarding.json";
import ja_orders from "./locales/ja/orders.json";
import ja_payments from "./locales/ja/payments.json";
import ja_portal from "./locales/ja/portal.json";
import ja_prototypes from "./locales/ja/prototypes.json";
import ja_purchases from "./locales/ja/purchases.json";
import ja_routing from "./locales/ja/routing.json";
import ja_scripts from "./locales/ja/scripts.json";
import ja_settings from "./locales/ja/settings.json";
import ja_shop from "./locales/ja/shop.json";
import ja_sidebar from "./locales/ja/sidebar.json";
import ja_tags from "./locales/ja/tags.json";
import ja_team_chat from "./locales/ja/team-chat.json";
import ja_team_channel from "./locales/ja/team_channel.json";
import ja_templates from "./locales/ja/templates.json";
import ja_test from "./locales/ja/test.json";
import ja_ticket_queues from "./locales/ja/ticket-queues.json";
import ja_tickets from "./locales/ja/tickets.json";
import ja_timeline from "./locales/ja/timeline.json";
import ja_ui from "./locales/ja/ui.json";
import ja_unsubscribe from "./locales/ja/unsubscribe.json";
import ja_utils from "./locales/ja/utils.json";
import ja_videoCalling from "./locales/ja/videoCalling.json";
import ja_vitals from "./locales/ja/vitals.json";
import ko_account from "./locales/ko/account.json";
import ko_ai_agent from "./locales/ko/ai-agent.json";
import ko_ai from "./locales/ko/ai.json";
import ko_analytics from "./locales/ko/analytics.json";
import ko_appointment_reminders from "./locales/ko/appointment-reminders.json";
import ko_appointments from "./locales/ko/appointments.json";
import ko_auth from "./locales/ko/auth.json";
import ko_button from "./locales/ko/button.json";
import ko_buttons from "./locales/ko/buttons.json";
import ko_calendar from "./locales/ko/calendar.json";
import ko_call_queues from "./locales/ko/call-queues.json";
import ko_calling from "./locales/ko/calling.json";
import ko_common from "./locales/ko/common.json";
import ko_compose from "./locales/ko/compose.json";
import ko_contact from "./locales/ko/contact.json";
import ko_contacts from "./locales/ko/contacts.json";
import ko_content from "./locales/ko/content.json";
import ko_dashboard from "./locales/ko/dashboard.json";
import ko_dates from "./locales/ko/dates.json";
import ko_device_orders from "./locales/ko/device-orders.json";
import ko_eligibility from "./locales/ko/eligibility.json";
import ko_email from "./locales/ko/email.json";
import ko_emojis from "./locales/ko/emojis.json";
import ko_encounters from "./locales/ko/encounters.json";
import ko_endusers from "./locales/ko/endusers.json";
import ko_events from "./locales/ko/events.json";
import ko_files from "./locales/ko/files.json";
import ko_forms from "./locales/ko/forms.json";
import ko_inbox from "./locales/ko/inbox.json";
import ko_layout from "./locales/ko/layout.json";
import ko_llm_testbench from "./locales/ko/llm-testbench.json";
import ko_medications from "./locales/ko/medications.json";
import ko_messages from "./locales/ko/messages.json";
import ko_messaging from "./locales/ko/messaging.json";
import ko_mfa from "./locales/ko/mfa.json";
import ko_missing from "./locales/ko/missing.json";
import ko_navigation from "./locales/ko/navigation.json";
import ko_notifications from "./locales/ko/notifications.json";
import ko_onboarding from "./locales/ko/onboarding.json";
import ko_orders from "./locales/ko/orders.json";
import ko_payments from "./locales/ko/payments.json";
import ko_portal from "./locales/ko/portal.json";
import ko_prototypes from "./locales/ko/prototypes.json";
import ko_purchases from "./locales/ko/purchases.json";
import ko_routing from "./locales/ko/routing.json";
import ko_scripts from "./locales/ko/scripts.json";
import ko_settings from "./locales/ko/settings.json";
import ko_shop from "./locales/ko/shop.json";
import ko_sidebar from "./locales/ko/sidebar.json";
import ko_tags from "./locales/ko/tags.json";
import ko_team_chat from "./locales/ko/team-chat.json";
import ko_team_channel from "./locales/ko/team_channel.json";
import ko_templates from "./locales/ko/templates.json";
import ko_test from "./locales/ko/test.json";
import ko_ticket_queues from "./locales/ko/ticket-queues.json";
import ko_tickets from "./locales/ko/tickets.json";
import ko_timeline from "./locales/ko/timeline.json";
import ko_ui from "./locales/ko/ui.json";
import ko_unsubscribe from "./locales/ko/unsubscribe.json";
import ko_utils from "./locales/ko/utils.json";
import ko_videoCalling from "./locales/ko/videoCalling.json";
import ko_vitals from "./locales/ko/vitals.json";
import pt_account from "./locales/pt/account.json";
import pt_ai_agent from "./locales/pt/ai-agent.json";
import pt_ai from "./locales/pt/ai.json";
import pt_analytics from "./locales/pt/analytics.json";
import pt_appointment_reminders from "./locales/pt/appointment-reminders.json";
import pt_appointments from "./locales/pt/appointments.json";
import pt_auth from "./locales/pt/auth.json";
import pt_button from "./locales/pt/button.json";
import pt_buttons from "./locales/pt/buttons.json";
import pt_calendar from "./locales/pt/calendar.json";
import pt_call_queues from "./locales/pt/call-queues.json";
import pt_calling from "./locales/pt/calling.json";
import pt_common from "./locales/pt/common.json";
import pt_compose from "./locales/pt/compose.json";
import pt_contact from "./locales/pt/contact.json";
import pt_contacts from "./locales/pt/contacts.json";
import pt_content from "./locales/pt/content.json";
import pt_dashboard from "./locales/pt/dashboard.json";
import pt_dates from "./locales/pt/dates.json";
import pt_device_orders from "./locales/pt/device-orders.json";
import pt_eligibility from "./locales/pt/eligibility.json";
import pt_email from "./locales/pt/email.json";
import pt_emojis from "./locales/pt/emojis.json";
import pt_encounters from "./locales/pt/encounters.json";
import pt_endusers from "./locales/pt/endusers.json";
import pt_events from "./locales/pt/events.json";
import pt_files from "./locales/pt/files.json";
import pt_forms from "./locales/pt/forms.json";
import pt_inbox from "./locales/pt/inbox.json";
import pt_layout from "./locales/pt/layout.json";
import pt_llm_testbench from "./locales/pt/llm-testbench.json";
import pt_medications from "./locales/pt/medications.json";
import pt_messages from "./locales/pt/messages.json";
import pt_messaging from "./locales/pt/messaging.json";
import pt_mfa from "./locales/pt/mfa.json";
import pt_missing from "./locales/pt/missing.json";
import pt_navigation from "./locales/pt/navigation.json";
import pt_notifications from "./locales/pt/notifications.json";
import pt_onboarding from "./locales/pt/onboarding.json";
import pt_orders from "./locales/pt/orders.json";
import pt_payments from "./locales/pt/payments.json";
import pt_portal from "./locales/pt/portal.json";
import pt_prototypes from "./locales/pt/prototypes.json";
import pt_purchases from "./locales/pt/purchases.json";
import pt_routing from "./locales/pt/routing.json";
import pt_scripts from "./locales/pt/scripts.json";
import pt_settings from "./locales/pt/settings.json";
import pt_shop from "./locales/pt/shop.json";
import pt_sidebar from "./locales/pt/sidebar.json";
import pt_tags from "./locales/pt/tags.json";
import pt_team_chat from "./locales/pt/team-chat.json";
import pt_team_channel from "./locales/pt/team_channel.json";
import pt_templates from "./locales/pt/templates.json";
import pt_test from "./locales/pt/test.json";
import pt_ticket_queues from "./locales/pt/ticket-queues.json";
import pt_tickets from "./locales/pt/tickets.json";
import pt_timeline from "./locales/pt/timeline.json";
import pt_ui from "./locales/pt/ui.json";
import pt_unsubscribe from "./locales/pt/unsubscribe.json";
import pt_utils from "./locales/pt/utils.json";
import pt_videoCalling from "./locales/pt/videoCalling.json";
import pt_vitals from "./locales/pt/vitals.json";
import ru_account from "./locales/ru/account.json";
import ru_ai_agent from "./locales/ru/ai-agent.json";
import ru_ai from "./locales/ru/ai.json";
import ru_analytics from "./locales/ru/analytics.json";
import ru_appointment_reminders from "./locales/ru/appointment-reminders.json";
import ru_appointments from "./locales/ru/appointments.json";
import ru_auth from "./locales/ru/auth.json";
import ru_button from "./locales/ru/button.json";
import ru_buttons from "./locales/ru/buttons.json";
import ru_calendar from "./locales/ru/calendar.json";
import ru_call_queues from "./locales/ru/call-queues.json";
import ru_calling from "./locales/ru/calling.json";
import ru_common from "./locales/ru/common.json";
import ru_compose from "./locales/ru/compose.json";
import ru_contact from "./locales/ru/contact.json";
import ru_contacts from "./locales/ru/contacts.json";
import ru_content from "./locales/ru/content.json";
import ru_dashboard from "./locales/ru/dashboard.json";
import ru_dates from "./locales/ru/dates.json";
import ru_device_orders from "./locales/ru/device-orders.json";
import ru_eligibility from "./locales/ru/eligibility.json";
import ru_email from "./locales/ru/email.json";
import ru_emojis from "./locales/ru/emojis.json";
import ru_encounters from "./locales/ru/encounters.json";
import ru_endusers from "./locales/ru/endusers.json";
import ru_events from "./locales/ru/events.json";
import ru_files from "./locales/ru/files.json";
import ru_forms from "./locales/ru/forms.json";
import ru_inbox from "./locales/ru/inbox.json";
import ru_layout from "./locales/ru/layout.json";
import ru_llm_testbench from "./locales/ru/llm-testbench.json";
import ru_medications from "./locales/ru/medications.json";
import ru_messages from "./locales/ru/messages.json";
import ru_messaging from "./locales/ru/messaging.json";
import ru_mfa from "./locales/ru/mfa.json";
import ru_missing from "./locales/ru/missing.json";
import ru_navigation from "./locales/ru/navigation.json";
import ru_notifications from "./locales/ru/notifications.json";
import ru_onboarding from "./locales/ru/onboarding.json";
import ru_orders from "./locales/ru/orders.json";
import ru_payments from "./locales/ru/payments.json";
import ru_portal from "./locales/ru/portal.json";
import ru_prototypes from "./locales/ru/prototypes.json";
import ru_purchases from "./locales/ru/purchases.json";
import ru_routing from "./locales/ru/routing.json";
import ru_scripts from "./locales/ru/scripts.json";
import ru_settings from "./locales/ru/settings.json";
import ru_shop from "./locales/ru/shop.json";
import ru_sidebar from "./locales/ru/sidebar.json";
import ru_tags from "./locales/ru/tags.json";
import ru_team_chat from "./locales/ru/team-chat.json";
import ru_team_channel from "./locales/ru/team_channel.json";
import ru_templates from "./locales/ru/templates.json";
import ru_test from "./locales/ru/test.json";
import ru_ticket_queues from "./locales/ru/ticket-queues.json";
import ru_tickets from "./locales/ru/tickets.json";
import ru_timeline from "./locales/ru/timeline.json";
import ru_ui from "./locales/ru/ui.json";
import ru_unsubscribe from "./locales/ru/unsubscribe.json";
import ru_utils from "./locales/ru/utils.json";
import ru_videoCalling from "./locales/ru/videoCalling.json";
import ru_vitals from "./locales/ru/vitals.json";
import tl_account from "./locales/tl/account.json";
import tl_ai_agent from "./locales/tl/ai-agent.json";
import tl_ai from "./locales/tl/ai.json";
import tl_analytics from "./locales/tl/analytics.json";
import tl_appointment_reminders from "./locales/tl/appointment-reminders.json";
import tl_appointments from "./locales/tl/appointments.json";
import tl_auth from "./locales/tl/auth.json";
import tl_button from "./locales/tl/button.json";
import tl_buttons from "./locales/tl/buttons.json";
import tl_calendar from "./locales/tl/calendar.json";
import tl_call_queues from "./locales/tl/call-queues.json";
import tl_calling from "./locales/tl/calling.json";
import tl_common from "./locales/tl/common.json";
import tl_compose from "./locales/tl/compose.json";
import tl_contact from "./locales/tl/contact.json";
import tl_contacts from "./locales/tl/contacts.json";
import tl_content from "./locales/tl/content.json";
import tl_dashboard from "./locales/tl/dashboard.json";
import tl_dates from "./locales/tl/dates.json";
import tl_device_orders from "./locales/tl/device-orders.json";
import tl_eligibility from "./locales/tl/eligibility.json";
import tl_email from "./locales/tl/email.json";
import tl_emojis from "./locales/tl/emojis.json";
import tl_encounters from "./locales/tl/encounters.json";
import tl_endusers from "./locales/tl/endusers.json";
import tl_events from "./locales/tl/events.json";
import tl_files from "./locales/tl/files.json";
import tl_forms from "./locales/tl/forms.json";
import tl_inbox from "./locales/tl/inbox.json";
import tl_layout from "./locales/tl/layout.json";
import tl_llm_testbench from "./locales/tl/llm-testbench.json";
import tl_medications from "./locales/tl/medications.json";
import tl_messages from "./locales/tl/messages.json";
import tl_messaging from "./locales/tl/messaging.json";
import tl_mfa from "./locales/tl/mfa.json";
import tl_missing from "./locales/tl/missing.json";
import tl_navigation from "./locales/tl/navigation.json";
import tl_notifications from "./locales/tl/notifications.json";
import tl_onboarding from "./locales/tl/onboarding.json";
import tl_orders from "./locales/tl/orders.json";
import tl_payments from "./locales/tl/payments.json";
import tl_portal from "./locales/tl/portal.json";
import tl_prototypes from "./locales/tl/prototypes.json";
import tl_purchases from "./locales/tl/purchases.json";
import tl_routing from "./locales/tl/routing.json";
import tl_scripts from "./locales/tl/scripts.json";
import tl_settings from "./locales/tl/settings.json";
import tl_shop from "./locales/tl/shop.json";
import tl_sidebar from "./locales/tl/sidebar.json";
import tl_tags from "./locales/tl/tags.json";
import tl_team_chat from "./locales/tl/team-chat.json";
import tl_team_channel from "./locales/tl/team_channel.json";
import tl_templates from "./locales/tl/templates.json";
import tl_test from "./locales/tl/test.json";
import tl_ticket_queues from "./locales/tl/ticket-queues.json";
import tl_tickets from "./locales/tl/tickets.json";
import tl_timeline from "./locales/tl/timeline.json";
import tl_ui from "./locales/tl/ui.json";
import tl_unsubscribe from "./locales/tl/unsubscribe.json";
import tl_utils from "./locales/tl/utils.json";
import tl_videoCalling from "./locales/tl/videoCalling.json";
import tl_vitals from "./locales/tl/vitals.json";
import vi_account from "./locales/vi/account.json";
import vi_ai_agent from "./locales/vi/ai-agent.json";
import vi_ai from "./locales/vi/ai.json";
import vi_analytics from "./locales/vi/analytics.json";
import vi_appointment_reminders from "./locales/vi/appointment-reminders.json";
import vi_appointments from "./locales/vi/appointments.json";
import vi_auth from "./locales/vi/auth.json";
import vi_button from "./locales/vi/button.json";
import vi_buttons from "./locales/vi/buttons.json";
import vi_calendar from "./locales/vi/calendar.json";
import vi_call_queues from "./locales/vi/call-queues.json";
import vi_calling from "./locales/vi/calling.json";
import vi_common from "./locales/vi/common.json";
import vi_compose from "./locales/vi/compose.json";
import vi_contact from "./locales/vi/contact.json";
import vi_contacts from "./locales/vi/contacts.json";
import vi_content from "./locales/vi/content.json";
import vi_dashboard from "./locales/vi/dashboard.json";
import vi_dates from "./locales/vi/dates.json";
import vi_device_orders from "./locales/vi/device-orders.json";
import vi_eligibility from "./locales/vi/eligibility.json";
import vi_email from "./locales/vi/email.json";
import vi_emojis from "./locales/vi/emojis.json";
import vi_encounters from "./locales/vi/encounters.json";
import vi_endusers from "./locales/vi/endusers.json";
import vi_events from "./locales/vi/events.json";
import vi_files from "./locales/vi/files.json";
import vi_forms from "./locales/vi/forms.json";
import vi_inbox from "./locales/vi/inbox.json";
import vi_layout from "./locales/vi/layout.json";
import vi_llm_testbench from "./locales/vi/llm-testbench.json";
import vi_medications from "./locales/vi/medications.json";
import vi_messages from "./locales/vi/messages.json";
import vi_messaging from "./locales/vi/messaging.json";
import vi_mfa from "./locales/vi/mfa.json";
import vi_missing from "./locales/vi/missing.json";
import vi_navigation from "./locales/vi/navigation.json";
import vi_notifications from "./locales/vi/notifications.json";
import vi_onboarding from "./locales/vi/onboarding.json";
import vi_orders from "./locales/vi/orders.json";
import vi_payments from "./locales/vi/payments.json";
import vi_portal from "./locales/vi/portal.json";
import vi_prototypes from "./locales/vi/prototypes.json";
import vi_purchases from "./locales/vi/purchases.json";
import vi_routing from "./locales/vi/routing.json";
import vi_scripts from "./locales/vi/scripts.json";
import vi_settings from "./locales/vi/settings.json";
import vi_shop from "./locales/vi/shop.json";
import vi_sidebar from "./locales/vi/sidebar.json";
import vi_tags from "./locales/vi/tags.json";
import vi_team_chat from "./locales/vi/team-chat.json";
import vi_team_channel from "./locales/vi/team_channel.json";
import vi_templates from "./locales/vi/templates.json";
import vi_test from "./locales/vi/test.json";
import vi_ticket_queues from "./locales/vi/ticket-queues.json";
import vi_tickets from "./locales/vi/tickets.json";
import vi_timeline from "./locales/vi/timeline.json";
import vi_ui from "./locales/vi/ui.json";
import vi_unsubscribe from "./locales/vi/unsubscribe.json";
import vi_utils from "./locales/vi/utils.json";
import vi_videoCalling from "./locales/vi/videoCalling.json";
import vi_vitals from "./locales/vi/vitals.json";
import zh_account from "./locales/zh/account.json";
import zh_ai_agent from "./locales/zh/ai-agent.json";
import zh_ai from "./locales/zh/ai.json";
import zh_analytics from "./locales/zh/analytics.json";
import zh_appointment_reminders from "./locales/zh/appointment-reminders.json";
import zh_appointments from "./locales/zh/appointments.json";
import zh_auth from "./locales/zh/auth.json";
import zh_button from "./locales/zh/button.json";
import zh_buttons from "./locales/zh/buttons.json";
import zh_calendar from "./locales/zh/calendar.json";
import zh_call_queues from "./locales/zh/call-queues.json";
import zh_calling from "./locales/zh/calling.json";
import zh_common from "./locales/zh/common.json";
import zh_compose from "./locales/zh/compose.json";
import zh_contact from "./locales/zh/contact.json";
import zh_contacts from "./locales/zh/contacts.json";
import zh_content from "./locales/zh/content.json";
import zh_dashboard from "./locales/zh/dashboard.json";
import zh_dates from "./locales/zh/dates.json";
import zh_device_orders from "./locales/zh/device-orders.json";
import zh_eligibility from "./locales/zh/eligibility.json";
import zh_email from "./locales/zh/email.json";
import zh_emojis from "./locales/zh/emojis.json";
import zh_encounters from "./locales/zh/encounters.json";
import zh_endusers from "./locales/zh/endusers.json";
import zh_events from "./locales/zh/events.json";
import zh_files from "./locales/zh/files.json";
import zh_forms from "./locales/zh/forms.json";
import zh_inbox from "./locales/zh/inbox.json";
import zh_layout from "./locales/zh/layout.json";
import zh_llm_testbench from "./locales/zh/llm-testbench.json";
import zh_medications from "./locales/zh/medications.json";
import zh_messages from "./locales/zh/messages.json";
import zh_messaging from "./locales/zh/messaging.json";
import zh_mfa from "./locales/zh/mfa.json";
import zh_missing from "./locales/zh/missing.json";
import zh_navigation from "./locales/zh/navigation.json";
import zh_notifications from "./locales/zh/notifications.json";
import zh_onboarding from "./locales/zh/onboarding.json";
import zh_orders from "./locales/zh/orders.json";
import zh_payments from "./locales/zh/payments.json";
import zh_portal from "./locales/zh/portal.json";
import zh_prototypes from "./locales/zh/prototypes.json";
import zh_purchases from "./locales/zh/purchases.json";
import zh_routing from "./locales/zh/routing.json";
import zh_scripts from "./locales/zh/scripts.json";
import zh_settings from "./locales/zh/settings.json";
import zh_shop from "./locales/zh/shop.json";
import zh_sidebar from "./locales/zh/sidebar.json";
import zh_tags from "./locales/zh/tags.json";
import zh_team_chat from "./locales/zh/team-chat.json";
import zh_team_channel from "./locales/zh/team_channel.json";
import zh_templates from "./locales/zh/templates.json";
import zh_test from "./locales/zh/test.json";
import zh_ticket_queues from "./locales/zh/ticket-queues.json";
import zh_tickets from "./locales/zh/tickets.json";
import zh_timeline from "./locales/zh/timeline.json";
import zh_ui from "./locales/zh/ui.json";
import zh_unsubscribe from "./locales/zh/unsubscribe.json";
import zh_utils from "./locales/zh/utils.json";
import zh_videoCalling from "./locales/zh/videoCalling.json";
import zh_vitals from "./locales/zh/vitals.json";

/** Every locale namespace on disk, sorted. */
export const localeNamespaces: readonly string[] = [
  "account",
  "ai",
  "ai-agent",
  "analytics",
  "appointment-reminders",
  "appointments",
  "auth",
  "button",
  "buttons",
  "calendar",
  "call-queues",
  "calling",
  "common",
  "compose",
  "contact",
  "contacts",
  "content",
  "dashboard",
  "dates",
  "device-orders",
  "eligibility",
  "email",
  "emojis",
  "encounters",
  "endusers",
  "events",
  "files",
  "forms",
  "inbox",
  "layout",
  "llm-testbench",
  "medications",
  "messages",
  "messaging",
  "mfa",
  "missing",
  "navigation",
  "notifications",
  "onboarding",
  "orders",
  "payments",
  "portal",
  "prototypes",
  "purchases",
  "routing",
  "scripts",
  "settings",
  "shop",
  "sidebar",
  "tags",
  "team-chat",
  "team_channel",
  "templates",
  "test",
  "ticket-queues",
  "tickets",
  "timeline",
  "ui",
  "unsubscribe",
  "utils",
  "videoCalling",
  "vitals",
];

/** All locale resources, keyed by language and then namespace. */
export const localeResources: Resource = {
  ar: {
    "account": ar_account,
    "ai-agent": ar_ai_agent,
    "ai": ar_ai,
    "analytics": ar_analytics,
    "appointment-reminders": ar_appointment_reminders,
    "appointments": ar_appointments,
    "auth": ar_auth,
    "button": ar_button,
    "buttons": ar_buttons,
    "calendar": ar_calendar,
    "call-queues": ar_call_queues,
    "calling": ar_calling,
    "common": ar_common,
    "compose": ar_compose,
    "contact": ar_contact,
    "contacts": ar_contacts,
    "content": ar_content,
    "dashboard": ar_dashboard,
    "dates": ar_dates,
    "device-orders": ar_device_orders,
    "eligibility": ar_eligibility,
    "email": ar_email,
    "emojis": ar_emojis,
    "encounters": ar_encounters,
    "endusers": ar_endusers,
    "events": ar_events,
    "files": ar_files,
    "forms": ar_forms,
    "inbox": ar_inbox,
    "layout": ar_layout,
    "llm-testbench": ar_llm_testbench,
    "medications": ar_medications,
    "messages": ar_messages,
    "messaging": ar_messaging,
    "mfa": ar_mfa,
    "missing": ar_missing,
    "navigation": ar_navigation,
    "notifications": ar_notifications,
    "onboarding": ar_onboarding,
    "orders": ar_orders,
    "payments": ar_payments,
    "portal": ar_portal,
    "prototypes": ar_prototypes,
    "purchases": ar_purchases,
    "routing": ar_routing,
    "scripts": ar_scripts,
    "settings": ar_settings,
    "shop": ar_shop,
    "sidebar": ar_sidebar,
    "tags": ar_tags,
    "team-chat": ar_team_chat,
    "team_channel": ar_team_channel,
    "templates": ar_templates,
    "test": ar_test,
    "ticket-queues": ar_ticket_queues,
    "tickets": ar_tickets,
    "timeline": ar_timeline,
    "ui": ar_ui,
    "unsubscribe": ar_unsubscribe,
    "utils": ar_utils,
    "videoCalling": ar_videoCalling,
    "vitals": ar_vitals,
  },
  de: {
    "account": de_account,
    "ai-agent": de_ai_agent,
    "ai": de_ai,
    "analytics": de_analytics,
    "appointment-reminders": de_appointment_reminders,
    "appointments": de_appointments,
    "auth": de_auth,
    "button": de_button,
    "buttons": de_buttons,
    "calendar": de_calendar,
    "call-queues": de_call_queues,
    "calling": de_calling,
    "common": de_common,
    "compose": de_compose,
    "contact": de_contact,
    "contacts": de_contacts,
    "content": de_content,
    "dashboard": de_dashboard,
    "dates": de_dates,
    "device-orders": de_device_orders,
    "eligibility": de_eligibility,
    "email": de_email,
    "emojis": de_emojis,
    "encounters": de_encounters,
    "endusers": de_endusers,
    "events": de_events,
    "files": de_files,
    "forms": de_forms,
    "inbox": de_inbox,
    "layout": de_layout,
    "llm-testbench": de_llm_testbench,
    "medications": de_medications,
    "messages": de_messages,
    "messaging": de_messaging,
    "mfa": de_mfa,
    "missing": de_missing,
    "navigation": de_navigation,
    "notifications": de_notifications,
    "onboarding": de_onboarding,
    "orders": de_orders,
    "payments": de_payments,
    "portal": de_portal,
    "prototypes": de_prototypes,
    "purchases": de_purchases,
    "routing": de_routing,
    "scripts": de_scripts,
    "settings": de_settings,
    "shop": de_shop,
    "sidebar": de_sidebar,
    "tags": de_tags,
    "team-chat": de_team_chat,
    "team_channel": de_team_channel,
    "templates": de_templates,
    "test": de_test,
    "ticket-queues": de_ticket_queues,
    "tickets": de_tickets,
    "timeline": de_timeline,
    "ui": de_ui,
    "unsubscribe": de_unsubscribe,
    "utils": de_utils,
    "videoCalling": de_videoCalling,
    "vitals": de_vitals,
  },
  en: {
    "account": en_account,
    "ai-agent": en_ai_agent,
    "ai": en_ai,
    "analytics": en_analytics,
    "appointment-reminders": en_appointment_reminders,
    "appointments": en_appointments,
    "auth": en_auth,
    "button": en_button,
    "buttons": en_buttons,
    "calendar": en_calendar,
    "call-queues": en_call_queues,
    "calling": en_calling,
    "common": en_common,
    "compose": en_compose,
    "contact": en_contact,
    "contacts": en_contacts,
    "content": en_content,
    "dashboard": en_dashboard,
    "dates": en_dates,
    "device-orders": en_device_orders,
    "eligibility": en_eligibility,
    "email": en_email,
    "emojis": en_emojis,
    "encounters": en_encounters,
    "endusers": en_endusers,
    "events": en_events,
    "files": en_files,
    "forms": en_forms,
    "inbox": en_inbox,
    "layout": en_layout,
    "llm-testbench": en_llm_testbench,
    "medications": en_medications,
    "messages": en_messages,
    "messaging": en_messaging,
    "mfa": en_mfa,
    "missing": en_missing,
    "navigation": en_navigation,
    "notifications": en_notifications,
    "onboarding": en_onboarding,
    "orders": en_orders,
    "payments": en_payments,
    "portal": en_portal,
    "prototypes": en_prototypes,
    "purchases": en_purchases,
    "routing": en_routing,
    "scripts": en_scripts,
    "settings": en_settings,
    "shop": en_shop,
    "sidebar": en_sidebar,
    "tags": en_tags,
    "team-chat": en_team_chat,
    "team_channel": en_team_channel,
    "templates": en_templates,
    "test": en_test,
    "ticket-queues": en_ticket_queues,
    "tickets": en_tickets,
    "timeline": en_timeline,
    "ui": en_ui,
    "unsubscribe": en_unsubscribe,
    "utils": en_utils,
    "videoCalling": en_videoCalling,
    "vitals": en_vitals,
  },
  es: {
    "account": es_account,
    "ai-agent": es_ai_agent,
    "ai": es_ai,
    "analytics": es_analytics,
    "appointment-reminders": es_appointment_reminders,
    "appointments": es_appointments,
    "auth": es_auth,
    "button": es_button,
    "buttons": es_buttons,
    "calendar": es_calendar,
    "call-queues": es_call_queues,
    "calling": es_calling,
    "common": es_common,
    "compose": es_compose,
    "contact": es_contact,
    "contacts": es_contacts,
    "content": es_content,
    "dashboard": es_dashboard,
    "dates": es_dates,
    "device-orders": es_device_orders,
    "eligibility": es_eligibility,
    "email": es_email,
    "emojis": es_emojis,
    "encounters": es_encounters,
    "endusers": es_endusers,
    "events": es_events,
    "files": es_files,
    "forms": es_forms,
    "inbox": es_inbox,
    "layout": es_layout,
    "llm-testbench": es_llm_testbench,
    "medications": es_medications,
    "messages": es_messages,
    "messaging": es_messaging,
    "mfa": es_mfa,
    "missing": es_missing,
    "navigation": es_navigation,
    "notifications": es_notifications,
    "onboarding": es_onboarding,
    "orders": es_orders,
    "payments": es_payments,
    "portal": es_portal,
    "prototypes": es_prototypes,
    "purchases": es_purchases,
    "routing": es_routing,
    "scripts": es_scripts,
    "settings": es_settings,
    "shop": es_shop,
    "sidebar": es_sidebar,
    "tags": es_tags,
    "team-chat": es_team_chat,
    "team_channel": es_team_channel,
    "templates": es_templates,
    "test": es_test,
    "ticket-queues": es_ticket_queues,
    "tickets": es_tickets,
    "timeline": es_timeline,
    "ui": es_ui,
    "unsubscribe": es_unsubscribe,
    "utils": es_utils,
    "videoCalling": es_videoCalling,
    "vitals": es_vitals,
  },
  fr: {
    "account": fr_account,
    "ai-agent": fr_ai_agent,
    "ai": fr_ai,
    "analytics": fr_analytics,
    "appointment-reminders": fr_appointment_reminders,
    "appointments": fr_appointments,
    "auth": fr_auth,
    "button": fr_button,
    "buttons": fr_buttons,
    "calendar": fr_calendar,
    "call-queues": fr_call_queues,
    "calling": fr_calling,
    "common": fr_common,
    "compose": fr_compose,
    "contact": fr_contact,
    "contacts": fr_contacts,
    "content": fr_content,
    "dashboard": fr_dashboard,
    "dates": fr_dates,
    "device-orders": fr_device_orders,
    "eligibility": fr_eligibility,
    "email": fr_email,
    "emojis": fr_emojis,
    "encounters": fr_encounters,
    "endusers": fr_endusers,
    "events": fr_events,
    "files": fr_files,
    "forms": fr_forms,
    "inbox": fr_inbox,
    "layout": fr_layout,
    "llm-testbench": fr_llm_testbench,
    "medications": fr_medications,
    "messages": fr_messages,
    "messaging": fr_messaging,
    "mfa": fr_mfa,
    "missing": fr_missing,
    "navigation": fr_navigation,
    "notifications": fr_notifications,
    "onboarding": fr_onboarding,
    "orders": fr_orders,
    "payments": fr_payments,
    "portal": fr_portal,
    "prototypes": fr_prototypes,
    "purchases": fr_purchases,
    "routing": fr_routing,
    "scripts": fr_scripts,
    "settings": fr_settings,
    "shop": fr_shop,
    "sidebar": fr_sidebar,
    "tags": fr_tags,
    "team-chat": fr_team_chat,
    "team_channel": fr_team_channel,
    "templates": fr_templates,
    "test": fr_test,
    "ticket-queues": fr_ticket_queues,
    "tickets": fr_tickets,
    "timeline": fr_timeline,
    "ui": fr_ui,
    "unsubscribe": fr_unsubscribe,
    "utils": fr_utils,
    "videoCalling": fr_videoCalling,
    "vitals": fr_vitals,
  },
  hi: {
    "account": hi_account,
    "ai-agent": hi_ai_agent,
    "ai": hi_ai,
    "analytics": hi_analytics,
    "appointment-reminders": hi_appointment_reminders,
    "appointments": hi_appointments,
    "auth": hi_auth,
    "button": hi_button,
    "buttons": hi_buttons,
    "calendar": hi_calendar,
    "call-queues": hi_call_queues,
    "calling": hi_calling,
    "common": hi_common,
    "compose": hi_compose,
    "contact": hi_contact,
    "contacts": hi_contacts,
    "content": hi_content,
    "dashboard": hi_dashboard,
    "dates": hi_dates,
    "device-orders": hi_device_orders,
    "eligibility": hi_eligibility,
    "email": hi_email,
    "emojis": hi_emojis,
    "encounters": hi_encounters,
    "endusers": hi_endusers,
    "events": hi_events,
    "files": hi_files,
    "forms": hi_forms,
    "inbox": hi_inbox,
    "layout": hi_layout,
    "llm-testbench": hi_llm_testbench,
    "medications": hi_medications,
    "messages": hi_messages,
    "messaging": hi_messaging,
    "mfa": hi_mfa,
    "missing": hi_missing,
    "navigation": hi_navigation,
    "notifications": hi_notifications,
    "onboarding": hi_onboarding,
    "orders": hi_orders,
    "payments": hi_payments,
    "portal": hi_portal,
    "prototypes": hi_prototypes,
    "purchases": hi_purchases,
    "routing": hi_routing,
    "scripts": hi_scripts,
    "settings": hi_settings,
    "shop": hi_shop,
    "sidebar": hi_sidebar,
    "tags": hi_tags,
    "team-chat": hi_team_chat,
    "team_channel": hi_team_channel,
    "templates": hi_templates,
    "test": hi_test,
    "ticket-queues": hi_ticket_queues,
    "tickets": hi_tickets,
    "timeline": hi_timeline,
    "ui": hi_ui,
    "unsubscribe": hi_unsubscribe,
    "utils": hi_utils,
    "videoCalling": hi_videoCalling,
    "vitals": hi_vitals,
  },
  ja: {
    "account": ja_account,
    "ai-agent": ja_ai_agent,
    "ai": ja_ai,
    "analytics": ja_analytics,
    "appointment-reminders": ja_appointment_reminders,
    "appointments": ja_appointments,
    "auth": ja_auth,
    "button": ja_button,
    "buttons": ja_buttons,
    "calendar": ja_calendar,
    "call-queues": ja_call_queues,
    "calling": ja_calling,
    "common": ja_common,
    "compose": ja_compose,
    "contact": ja_contact,
    "contacts": ja_contacts,
    "content": ja_content,
    "dashboard": ja_dashboard,
    "dates": ja_dates,
    "device-orders": ja_device_orders,
    "eligibility": ja_eligibility,
    "email": ja_email,
    "emojis": ja_emojis,
    "encounters": ja_encounters,
    "endusers": ja_endusers,
    "events": ja_events,
    "files": ja_files,
    "forms": ja_forms,
    "inbox": ja_inbox,
    "layout": ja_layout,
    "llm-testbench": ja_llm_testbench,
    "medications": ja_medications,
    "messages": ja_messages,
    "messaging": ja_messaging,
    "mfa": ja_mfa,
    "missing": ja_missing,
    "navigation": ja_navigation,
    "notifications": ja_notifications,
    "onboarding": ja_onboarding,
    "orders": ja_orders,
    "payments": ja_payments,
    "portal": ja_portal,
    "prototypes": ja_prototypes,
    "purchases": ja_purchases,
    "routing": ja_routing,
    "scripts": ja_scripts,
    "settings": ja_settings,
    "shop": ja_shop,
    "sidebar": ja_sidebar,
    "tags": ja_tags,
    "team-chat": ja_team_chat,
    "team_channel": ja_team_channel,
    "templates": ja_templates,
    "test": ja_test,
    "ticket-queues": ja_ticket_queues,
    "tickets": ja_tickets,
    "timeline": ja_timeline,
    "ui": ja_ui,
    "unsubscribe": ja_unsubscribe,
    "utils": ja_utils,
    "videoCalling": ja_videoCalling,
    "vitals": ja_vitals,
  },
  ko: {
    "account": ko_account,
    "ai-agent": ko_ai_agent,
    "ai": ko_ai,
    "analytics": ko_analytics,
    "appointment-reminders": ko_appointment_reminders,
    "appointments": ko_appointments,
    "auth": ko_auth,
    "button": ko_button,
    "buttons": ko_buttons,
    "calendar": ko_calendar,
    "call-queues": ko_call_queues,
    "calling": ko_calling,
    "common": ko_common,
    "compose": ko_compose,
    "contact": ko_contact,
    "contacts": ko_contacts,
    "content": ko_content,
    "dashboard": ko_dashboard,
    "dates": ko_dates,
    "device-orders": ko_device_orders,
    "eligibility": ko_eligibility,
    "email": ko_email,
    "emojis": ko_emojis,
    "encounters": ko_encounters,
    "endusers": ko_endusers,
    "events": ko_events,
    "files": ko_files,
    "forms": ko_forms,
    "inbox": ko_inbox,
    "layout": ko_layout,
    "llm-testbench": ko_llm_testbench,
    "medications": ko_medications,
    "messages": ko_messages,
    "messaging": ko_messaging,
    "mfa": ko_mfa,
    "missing": ko_missing,
    "navigation": ko_navigation,
    "notifications": ko_notifications,
    "onboarding": ko_onboarding,
    "orders": ko_orders,
    "payments": ko_payments,
    "portal": ko_portal,
    "prototypes": ko_prototypes,
    "purchases": ko_purchases,
    "routing": ko_routing,
    "scripts": ko_scripts,
    "settings": ko_settings,
    "shop": ko_shop,
    "sidebar": ko_sidebar,
    "tags": ko_tags,
    "team-chat": ko_team_chat,
    "team_channel": ko_team_channel,
    "templates": ko_templates,
    "test": ko_test,
    "ticket-queues": ko_ticket_queues,
    "tickets": ko_tickets,
    "timeline": ko_timeline,
    "ui": ko_ui,
    "unsubscribe": ko_unsubscribe,
    "utils": ko_utils,
    "videoCalling": ko_videoCalling,
    "vitals": ko_vitals,
  },
  pt: {
    "account": pt_account,
    "ai-agent": pt_ai_agent,
    "ai": pt_ai,
    "analytics": pt_analytics,
    "appointment-reminders": pt_appointment_reminders,
    "appointments": pt_appointments,
    "auth": pt_auth,
    "button": pt_button,
    "buttons": pt_buttons,
    "calendar": pt_calendar,
    "call-queues": pt_call_queues,
    "calling": pt_calling,
    "common": pt_common,
    "compose": pt_compose,
    "contact": pt_contact,
    "contacts": pt_contacts,
    "content": pt_content,
    "dashboard": pt_dashboard,
    "dates": pt_dates,
    "device-orders": pt_device_orders,
    "eligibility": pt_eligibility,
    "email": pt_email,
    "emojis": pt_emojis,
    "encounters": pt_encounters,
    "endusers": pt_endusers,
    "events": pt_events,
    "files": pt_files,
    "forms": pt_forms,
    "inbox": pt_inbox,
    "layout": pt_layout,
    "llm-testbench": pt_llm_testbench,
    "medications": pt_medications,
    "messages": pt_messages,
    "messaging": pt_messaging,
    "mfa": pt_mfa,
    "missing": pt_missing,
    "navigation": pt_navigation,
    "notifications": pt_notifications,
    "onboarding": pt_onboarding,
    "orders": pt_orders,
    "payments": pt_payments,
    "portal": pt_portal,
    "prototypes": pt_prototypes,
    "purchases": pt_purchases,
    "routing": pt_routing,
    "scripts": pt_scripts,
    "settings": pt_settings,
    "shop": pt_shop,
    "sidebar": pt_sidebar,
    "tags": pt_tags,
    "team-chat": pt_team_chat,
    "team_channel": pt_team_channel,
    "templates": pt_templates,
    "test": pt_test,
    "ticket-queues": pt_ticket_queues,
    "tickets": pt_tickets,
    "timeline": pt_timeline,
    "ui": pt_ui,
    "unsubscribe": pt_unsubscribe,
    "utils": pt_utils,
    "videoCalling": pt_videoCalling,
    "vitals": pt_vitals,
  },
  ru: {
    "account": ru_account,
    "ai-agent": ru_ai_agent,
    "ai": ru_ai,
    "analytics": ru_analytics,
    "appointment-reminders": ru_appointment_reminders,
    "appointments": ru_appointments,
    "auth": ru_auth,
    "button": ru_button,
    "buttons": ru_buttons,
    "calendar": ru_calendar,
    "call-queues": ru_call_queues,
    "calling": ru_calling,
    "common": ru_common,
    "compose": ru_compose,
    "contact": ru_contact,
    "contacts": ru_contacts,
    "content": ru_content,
    "dashboard": ru_dashboard,
    "dates": ru_dates,
    "device-orders": ru_device_orders,
    "eligibility": ru_eligibility,
    "email": ru_email,
    "emojis": ru_emojis,
    "encounters": ru_encounters,
    "endusers": ru_endusers,
    "events": ru_events,
    "files": ru_files,
    "forms": ru_forms,
    "inbox": ru_inbox,
    "layout": ru_layout,
    "llm-testbench": ru_llm_testbench,
    "medications": ru_medications,
    "messages": ru_messages,
    "messaging": ru_messaging,
    "mfa": ru_mfa,
    "missing": ru_missing,
    "navigation": ru_navigation,
    "notifications": ru_notifications,
    "onboarding": ru_onboarding,
    "orders": ru_orders,
    "payments": ru_payments,
    "portal": ru_portal,
    "prototypes": ru_prototypes,
    "purchases": ru_purchases,
    "routing": ru_routing,
    "scripts": ru_scripts,
    "settings": ru_settings,
    "shop": ru_shop,
    "sidebar": ru_sidebar,
    "tags": ru_tags,
    "team-chat": ru_team_chat,
    "team_channel": ru_team_channel,
    "templates": ru_templates,
    "test": ru_test,
    "ticket-queues": ru_ticket_queues,
    "tickets": ru_tickets,
    "timeline": ru_timeline,
    "ui": ru_ui,
    "unsubscribe": ru_unsubscribe,
    "utils": ru_utils,
    "videoCalling": ru_videoCalling,
    "vitals": ru_vitals,
  },
  tl: {
    "account": tl_account,
    "ai-agent": tl_ai_agent,
    "ai": tl_ai,
    "analytics": tl_analytics,
    "appointment-reminders": tl_appointment_reminders,
    "appointments": tl_appointments,
    "auth": tl_auth,
    "button": tl_button,
    "buttons": tl_buttons,
    "calendar": tl_calendar,
    "call-queues": tl_call_queues,
    "calling": tl_calling,
    "common": tl_common,
    "compose": tl_compose,
    "contact": tl_contact,
    "contacts": tl_contacts,
    "content": tl_content,
    "dashboard": tl_dashboard,
    "dates": tl_dates,
    "device-orders": tl_device_orders,
    "eligibility": tl_eligibility,
    "email": tl_email,
    "emojis": tl_emojis,
    "encounters": tl_encounters,
    "endusers": tl_endusers,
    "events": tl_events,
    "files": tl_files,
    "forms": tl_forms,
    "inbox": tl_inbox,
    "layout": tl_layout,
    "llm-testbench": tl_llm_testbench,
    "medications": tl_medications,
    "messages": tl_messages,
    "messaging": tl_messaging,
    "mfa": tl_mfa,
    "missing": tl_missing,
    "navigation": tl_navigation,
    "notifications": tl_notifications,
    "onboarding": tl_onboarding,
    "orders": tl_orders,
    "payments": tl_payments,
    "portal": tl_portal,
    "prototypes": tl_prototypes,
    "purchases": tl_purchases,
    "routing": tl_routing,
    "scripts": tl_scripts,
    "settings": tl_settings,
    "shop": tl_shop,
    "sidebar": tl_sidebar,
    "tags": tl_tags,
    "team-chat": tl_team_chat,
    "team_channel": tl_team_channel,
    "templates": tl_templates,
    "test": tl_test,
    "ticket-queues": tl_ticket_queues,
    "tickets": tl_tickets,
    "timeline": tl_timeline,
    "ui": tl_ui,
    "unsubscribe": tl_unsubscribe,
    "utils": tl_utils,
    "videoCalling": tl_videoCalling,
    "vitals": tl_vitals,
  },
  vi: {
    "account": vi_account,
    "ai-agent": vi_ai_agent,
    "ai": vi_ai,
    "analytics": vi_analytics,
    "appointment-reminders": vi_appointment_reminders,
    "appointments": vi_appointments,
    "auth": vi_auth,
    "button": vi_button,
    "buttons": vi_buttons,
    "calendar": vi_calendar,
    "call-queues": vi_call_queues,
    "calling": vi_calling,
    "common": vi_common,
    "compose": vi_compose,
    "contact": vi_contact,
    "contacts": vi_contacts,
    "content": vi_content,
    "dashboard": vi_dashboard,
    "dates": vi_dates,
    "device-orders": vi_device_orders,
    "eligibility": vi_eligibility,
    "email": vi_email,
    "emojis": vi_emojis,
    "encounters": vi_encounters,
    "endusers": vi_endusers,
    "events": vi_events,
    "files": vi_files,
    "forms": vi_forms,
    "inbox": vi_inbox,
    "layout": vi_layout,
    "llm-testbench": vi_llm_testbench,
    "medications": vi_medications,
    "messages": vi_messages,
    "messaging": vi_messaging,
    "mfa": vi_mfa,
    "missing": vi_missing,
    "navigation": vi_navigation,
    "notifications": vi_notifications,
    "onboarding": vi_onboarding,
    "orders": vi_orders,
    "payments": vi_payments,
    "portal": vi_portal,
    "prototypes": vi_prototypes,
    "purchases": vi_purchases,
    "routing": vi_routing,
    "scripts": vi_scripts,
    "settings": vi_settings,
    "shop": vi_shop,
    "sidebar": vi_sidebar,
    "tags": vi_tags,
    "team-chat": vi_team_chat,
    "team_channel": vi_team_channel,
    "templates": vi_templates,
    "test": vi_test,
    "ticket-queues": vi_ticket_queues,
    "tickets": vi_tickets,
    "timeline": vi_timeline,
    "ui": vi_ui,
    "unsubscribe": vi_unsubscribe,
    "utils": vi_utils,
    "videoCalling": vi_videoCalling,
    "vitals": vi_vitals,
  },
  zh: {
    "account": zh_account,
    "ai-agent": zh_ai_agent,
    "ai": zh_ai,
    "analytics": zh_analytics,
    "appointment-reminders": zh_appointment_reminders,
    "appointments": zh_appointments,
    "auth": zh_auth,
    "button": zh_button,
    "buttons": zh_buttons,
    "calendar": zh_calendar,
    "call-queues": zh_call_queues,
    "calling": zh_calling,
    "common": zh_common,
    "compose": zh_compose,
    "contact": zh_contact,
    "contacts": zh_contacts,
    "content": zh_content,
    "dashboard": zh_dashboard,
    "dates": zh_dates,
    "device-orders": zh_device_orders,
    "eligibility": zh_eligibility,
    "email": zh_email,
    "emojis": zh_emojis,
    "encounters": zh_encounters,
    "endusers": zh_endusers,
    "events": zh_events,
    "files": zh_files,
    "forms": zh_forms,
    "inbox": zh_inbox,
    "layout": zh_layout,
    "llm-testbench": zh_llm_testbench,
    "medications": zh_medications,
    "messages": zh_messages,
    "messaging": zh_messaging,
    "mfa": zh_mfa,
    "missing": zh_missing,
    "navigation": zh_navigation,
    "notifications": zh_notifications,
    "onboarding": zh_onboarding,
    "orders": zh_orders,
    "payments": zh_payments,
    "portal": zh_portal,
    "prototypes": zh_prototypes,
    "purchases": zh_purchases,
    "routing": zh_routing,
    "scripts": zh_scripts,
    "settings": zh_settings,
    "shop": zh_shop,
    "sidebar": zh_sidebar,
    "tags": zh_tags,
    "team-chat": zh_team_chat,
    "team_channel": zh_team_channel,
    "templates": zh_templates,
    "test": zh_test,
    "ticket-queues": zh_ticket_queues,
    "tickets": zh_tickets,
    "timeline": zh_timeline,
    "ui": zh_ui,
    "unsubscribe": zh_unsubscribe,
    "utils": zh_utils,
    "videoCalling": zh_videoCalling,
    "vitals": zh_vitals,
  },
};
